module.exports = __webpack_public_path__ + "static/media/textediter_numberlist.1cc796dd.svg";